
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M17.363 11.313h-4.576V6.736a.737.737 0 00-1.473 0v4.577H6.736a.737.737 0 000 1.473h4.578v4.577a.737.737 0 101.473 0v-4.577h4.576a.737.737 0 000-1.473z"}})])
          )
        }
      }
    